<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">{{ $t("message.admin.index") }}</h4>
            </div>
            <div class="card-body px-3 py-5 text-center">
              <!-- <router-link :to="{name: 'admin-registrations'}" class="btn w-25 btn-default" >{{$t('message.admin.registrations')}}</router-link>
                            <br>
                            <router-link :to="{name: 'admin-users'}" class="btn w-25 btn-default" >{{$t('message.admin.users')}}</router-link>
                            <br>
                            <router-link :to="{name: 'admin-logs'}" class="btn w-25 btn-default" >{{$t('message.admin.logs')}}</router-link>
                            <br>
                            <router-link :to="{name: 'admin-operations'}" class="btn w-25 btn-default" >{{$t('message.admin.operations')}}</router-link>
							<br>
                            <router-link :to="{name: 'admin-toc-offers'}" class="btn w-25 btn-default" >{{$t('message.admin.toc-offers')}}</router-link>
							<br>
                            <router-link :to="{name: 'admin-sad-builder'}" class="btn w-25 btn-default" >Конструктор ГТД</router-link>
							<br>
							<router-link :to="{name: 'admin-ca-history'}" class="btn w-25 btn-default" >{{$t('message.admin.ca-history')}}</router-link>
							<br>
							<router-link :to="{name: 'admin-news'}" class="btn w-25 btn-default" >{{$t('message.admin.news')}}</router-link>
							<br>
							<router-link :to="{name: 'admin-service-prices'}" class="btn w-25 btn-default" >{{$t('message.admin.serviceprices')}}</router-link>
							<br>
							<router-link :to="{name: 'admin-operations-history'}" class="btn w-25 btn-default" >{{$t('message.account.operation_history')}}</router-link> -->

              <button
                class="btn btn-secondary"
                style=""
                @click.prevent="toggleContracts"
              >
                <span v-if="is_contracts">Выключить меню контрактов</span>
                <span v-else>Включить меню контрактов</span>
              </button>

              <hr class="my-4" />

              <h5 class="mb-3 text-left font-weight-bold ">{{ $t('message.admin.settings') }}</h5>

              <div class="d-flex flex-column align-items-start mb-3">
                <label class="mb-1">{{ $t('message.admin.business_score_default_year') }}</label>
                <select
                  class="form-control"
                  style="width: 140px; height: 40px"
                  v-model="businessScoreDefaultYear"
                >
                  <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
                </select>
              </div>

              <div class="text-left">
                <button
                  style="height: 40px"
                  class="btn btn-primary"
                  @click="saveAllSettings"
                >
                  {{ $t('message.save') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "admin-index",
  data() {
    return {
      is_contracts: false,
      businessScoreDefaultYear: null,
    };
  },
  mounted() {
    let status = localStorage.getItem("attis-contracts");
    if (null == status) status = "0";
    this.is_contracts = parseInt(status);
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.loadSettings();
  },
  methods: {
    toggleContracts() {
      this.is_contracts = this.is_contracts == 0 ? 1 : 0;
      localStorage.setItem("attis-contracts", this.is_contracts);
      this.$root.$emit("contractMenuChanged");
    },
    loadSettings() {
      axios.get(window.base + "/account/GetAdminSettings").then((res) => {
        const settings = res.data || {};
        this.businessScoreDefaultYear = settings.businessScoreDefaultYear ? Number(settings.businessScoreDefaultYear) : null;
      }).catch((e) => {
        console.error("Load settings error:", e);
      });
    },
    saveAllSettings() {
      const settings = {
        businessScoreDefaultYear: this.businessScoreDefaultYear ? String(this.businessScoreDefaultYear) : "",
      };
      this.saveSettings(settings);
    },
    saveSettings(settingsToSave) {
      axios.post(window.base + "/account/SaveAdminSettings", settingsToSave).then(() => {
        Object.assign(this.$data, settingsToSave);
      }).catch((e) => {
      });
    },
  },
  computed: {
    yearOptions() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let y = currentYear; y >= currentYear - 40; y--) {
        years.push(y);
      }
      return years;
    },
  },
};
</script>
